var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ew-container",attrs:{"id":_vm.cameraCanvasContainer}},[_c('canvas',{attrs:{"id":_vm.cameraCanvas}}),(!_vm.hasSeenImageTarget)?_c('Overlay'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }